// GPLv3, Copyright (C) 2017, theBlock, https://theblock.io
// @flow

export default {
  address: {
    text: 'on my selected account'
  },
  name: {
    text: 'identified by the name',
    defaultName: 'no name'
  },
  balance: {
    text: 'there is a balance of'
  },
  value: {
    text: 'valued at'
  },
  transactions: {
    powered: 'powered by {{explorer}}',
    received: 'received {{value}}',
    sent: 'sent {{value}}'
  }
};



// WEBPACK FOOTER //
// ./packages/page-index/i18n/en/accounts.js